export default __webpack_public_path__ + "static/banana-6fea1fd32ca087a2b7c5c38d012b278a.webp";